const files = require.context(".", false, /\.js$/);
let service = {};
files.keys().forEach((k) => {
  if (k === "./index.js") return;
  service[k.replace(/\.\/(.*)\.js/, "$1")] = files(k).default;
});
export default service;
